import Cookie from 'cookie'

export default class TokenHelper {
  static isTokenEncoded = (token: string): boolean => {
    return decodeURIComponent(token) !== token
  }

  static encodeToken = (token: string) => {
    return TokenHelper.isTokenEncoded(token) ? token : encodeURIComponent(token)
  }

  static getToken = () => {
    const hmVlcIntegration = Cookie.parse(document.cookie)?.hmVlcIntegration || ''

    return TokenHelper.encodeToken(hmVlcIntegration)
  }

  static hasToken = () => {
    return Boolean(TokenHelper.getToken())
  }
}
